module.exports = __webpack_public_path__ + "img/ozo_new.56a115cd.png";